import React from "react";
import SideNav from "@hid-galaxy-ui/galaxy-react/components/SideNav";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import BottomNavigationMenu from "../../../common/components/BottomNavigationMenu/BottomNavigationMenu";
import { useIsHidStaff } from "../../../hooks/useIsHidStaff";
import "./HIDAdminDashboard.scss";

const POCDashboard = () => {
  const isHidStaff = useIsHidStaff();
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const pathNameArray = pathName.split("/");
  const isMobile = useMediaQuery("(max-width:1023px)");

  React.useEffect(() => {
    if (
      pathName === "/hid-admin/dashboard" ||
      pathName === "/hid-admin/dashboard/"
    )
      navigate("partner-list");
    const element = document.getElementById(
      pathNameArray[pathNameArray.length - 1]
    );
    element?.click();
  }, [pathName]);

  const onNodeClick = (e: any, key: any) => {
    if (key === "hid-admin-home") {
      navigate("/hid-admin/home");
    } else {
      navigate(key);
    }
  };

  const navItems = [
    {
      iconName: "home",
      key: "hid-admin-home",
      title: "Home",
    },
    {
      iconName: "listCheck",
      key: "feature-management",
      title: "Feature Management",
    },
    {
      iconName: "triangleExclamation",
      key: "incident-list",
      title: "Incident Management",
    },
    {
      iconName: "arrowsRotate",
      key: "health-checkup",
      title: "Health Checkups",
    },
    {
      iconName: "table",
      key: "feature-comparison",
      title: "Feature Comparison",
    },
  ];

  const mobileMenuData = [
    {
      iconName: "home",
      key: "hid-admin-home",
      title: "Home",
    },
    {
      iconName: "listCheck",
      key: "feature-management",
      title: "Feature Management",
    },
    
  ];

  const mobileMoreMenuData = [
    {
      iconName: "listCheck",
      key: "feature-management",
      title: "Feature Management",
    },
    {
      iconName: "triangleExclamation",
      key: "incident-list",
      title: "Incident Management",
    },
    {
      iconName: "arrowsRotate",
      key: "health-checkup",
      title: "Health Checkups",
    },
    {
      iconName: "table",
      key: "feature-comparison",
      title: "Feature Comparison",
    },
  ];

  return (
    <div className="hid-admin-dashboard-container">
      {isMobile ? (
        <BottomNavigationMenu
          menuData={mobileMenuData}
          moreMenuDataEnabled={isHidStaff}
          moreMenuData={mobileMoreMenuData}
        />
      ) : (
        <SideNav
          id="sidenav"
          mode="Colapsed"
          isToggle={false}
          selected={pathNameArray[pathNameArray.length - 1]}
          navItems={navItems}
          onNodeClick={(e, key) => onNodeClick(e, key)}
        />
      )}
      <div className="outlet-view">
        <Outlet />
      </div>
    </div>
  );
};

export default POCDashboard;
